"use client";

import React from 'react';
import { House as Home, Building2, Camera, FileText } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  title: "Roof Condition Surveys",
  icon: Home
}, {
  title: "Facade Condition Surveys",
  icon: Building2
}, {
  title: "Aerial Photography",
  icon: Camera
}, {
  title: "Progression Reports",
  icon: FileText
}];
export default function TheProcess() {
  return <section data-section-id="223933" id="mission-control-process" className="bg-background text-foreground py-20 lg:py-28">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                
                <div className="max-w-2xl lg:max-w-5xl mx-auto mb-12 lg:mb-16 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
                    <div className="text-center lg:text-left">
                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-serif uppercase tracking-wider text-foreground">
                            What We Do
                        </h2>
                        <p className="text-muted-foreground text-base sm:text-lg mt-4 font-default">
                            We work with homeowners and end users as well as professional services and businesses.
                        </p>
                    </div>
                    <div className="w-full">
                        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655034/img/aerial_drone_roof_survey.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655034/img/aerial_drone_roof_survey.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655034/img/aerial_drone_roof_survey.png-wvc-sizes" alt="Aerial drone survey of residential roof and property" loading="lazy" className="w-full h-64 lg:h-80 object-cover rounded-md border border-border" />
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
                    {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={service.title} data-index={index} className="flex items-center gap-4 p-5 rounded-md bg-card border border-border">
                                <div className="p-2.5 rounded-md bg-secondary/10 text-secondary shrink-0">
                                    <Icon className="size-5" />
                                </div>
                                <h3 className="text-base font-semibold font-default text-foreground">
                                    {service.title}
                                </h3>
                            </div>;
        })}
                </div>

                <div className="mt-16 lg:mt-20 text-center max-w-xl mx-auto p-8 rounded-md bg-card border border-border">
                    <h3 className="text-xl sm:text-2xl font-bold font-serif uppercase tracking-wider mb-4 text-foreground">
                        Ready to Discuss Your Project?
                    </h3>
                    <p className="text-muted-foreground text-sm sm:text-base mb-6 font-default">
                        Contact our team to arrange an aerial inspection or survey for your site.
                    </p>
                    <Button asChild size="lg" className="px-6 py-2.5 font-medium">
                        <Link to="#contact-us">
                            Get in Touch
                        </Link>
                    </Button>
                </div>

            </div>
        </section>;
}